export default "__VITE_ASSET__CNJX3aOl__"